import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import { BACKGROUND_TYPE } from '../../components/FJMainPreview/FJCreationEditPanel/js/FJPhotoRemoveBgCanvas';

export const DEFAULT_CUSTOM_EDIT_BG_IMAGE_DATA = {
    undoAndRedoData: {
        undoStack: [],
        redoStack: [],
    },
    bgData: {
        backgroundType: BACKGROUND_TYPE.TRANSPARENT,
        backgroundImage: null,
        backgroundColor: null,
    },
    strokeData: {
        type: 'none',
    },
    maskKey: null, // 当前 mask 的 key
    resetMaskKey: null, // 重置 mask 的 key
    originImgUrl: '',
    aiMaskData: null,
    taskStatus: FJConstant.DEFAULT,
    isPhotoRemoveBg: false,
    isSelected: true,
};

export const DEFAULT_AUTO_EDIT_BG_IMAGE_DATA = {
    id: '', // 唯一 id
    name: '', // 图片名称
    width: 0, // 图片宽度
    height: 0, // 图片高度
    bgData: {
        backgroundType: BACKGROUND_TYPE.TRANSPARENT,
        backgroundImage: null,
        backgroundColor: null,
    },
    strokeData: {
        type: 'none',
    },
    maskKey: null, // 当前 mask 的 key
    resetMaskKey: null, // 重置 mask 的 key
    originImgUrl: '',
    taskStatus: FJConstant.DEFAULT,
};

export const MENU_LIST = [
    {
        text: 'auto-remover',
    },
    {
        text: 'customize-remover',
    },
];

export const USE_CREDIT = 1;

export const FJSlicePhotoBgRemover = createSlice({
    name: 'photoBgRemover',
    initialState: {
        customEditBgImageData: null, // 自定义去背景图片数据

        autoBgImageDataList: [], // 自动去背景图片数据列表
        curSelectAutoBgImageIndex: 0, // 当前选中的自动去背景图片索引

        curMenuIndex: 0, // 当前选中的菜单索引

        bgApplyToAll: false, // 是否应用到所有图片
        strokeApplyToAll: false, // 是否应用到所有图片

        backgroundPhotoList: [], // 背景图片列表
        flexClipBgLoadStatus: FJConstant.DEFAULT, // flexClip 背景图片列表加载状态

        curSelectBgData: null, // 当前选中的背景图片数据
        curBgColor: '', // 当前选中的背景颜色

        autoBackgroundRemoveFreeNum: 0, // 自动去背景免费次数
        backgroundRemoveFreeNum: 0, // 去背景免费次数

        customUploadBgFileList: [], // 自定义上传背景图片列表

        bgUsePhotoLoadingList: [], // 背景图片使用中列表

        thumbnailList: [], // 缩略图列表
    },
    reducers: {
        setSliceCustomEditBgImageData: (state, action) => {
            state.customEditBgImageData = action.payload;
        },

        setSliceAutoBgImageDataList: (state, action) => {
            state.autoBgImageDataList = action.payload;
        },

        setSliceCurSelectAutoBgImageIndex: (state, action) => {
            state.curSelectAutoBgImageIndex = action.payload;
        },

        setSliceCurMenuIndex: (state, action) => {
            state.curMenuIndex = action.payload;
        },

        setSliceBgApplyToAll: (state, action) => {
            state.bgApplyToAll = action.payload;
        },

        setSliceStrokeApplyToAll: (state, action) => {
            state.strokeApplyToAll = action.payload;
        },

        setSliceBackgroundPhotoList: (state, action) => {
            state.backgroundPhotoList = action.payload;
        },

        setSliceFlexClipBackgroundLoadStatus: (state, action) => {
            state.flexClipBgLoadStatus = action.payload;
        },

        setSliceCurSelectBgData: (state, action) => {
            state.curSelectBgData = action.payload;
        },

        setSliceCurBgColor: (state, action) => {
            state.curBgColor = action.payload;
        },

        setSliceAutoBackgroundRemoveFreeNum: (state, action) => {
            state.autoBackgroundRemoveFreeNum = action.payload;
        },

        setSliceBackgroundRemoveFreeNum: (state, action) => {
            state.backgroundRemoveFreeNum = action.payload;
        },

        setSliceCustomUploadBgFileList: (state, action) => {
            state.customUploadBgFileList = action.payload;
        },

        setSliceBgUsePhotoLoadingList: (state, action) => {
            state.bgUsePhotoLoadingList = action.payload;
        },

        setSliceThumbnailList: (state, action) => {
            state.thumbnailList = action.payload;
        },
    },
});

export const {
    setSliceCustomEditBgImageData,
    setSliceAutoBgImageDataList,
    setSliceCurSelectAutoBgImageIndex,
    setSliceCurMenuIndex,
    setSliceBgApplyToAll,
    setSliceStrokeApplyToAll,
    setSliceBackgroundPhotoList,
    setSliceFlexClipBackgroundLoadStatus,
    setSliceCurSelectBgData,
    setSliceCurBgColor,
    setSliceAutoBackgroundRemoveFreeNum,
    setSliceBackgroundRemoveFreeNum,
    setSliceCustomUploadBgFileList,
    setSliceBgUsePhotoLoadingList,
    setSliceThumbnailList,
} = FJSlicePhotoBgRemover.actions;

export default FJSlicePhotoBgRemover.reducer;
